import { NAV_STORAGE_KEY } from "@wcp/shared";
import { useState } from "react";
import { NavLink } from "react-router";
import { Icon } from "./Icon.js";
import styles from "./NavRail.module.css";
import { NAV } from "./nav.js";

/**
 * Grouped left nav (handoff README §Screens). aiEnabled=false hides the AI Agent
 * entry — the feature-flag cascade (doc 01 §1.8); the flag wires to the server in
 * Phase 9. Collapse state persists in localStorage 'hillman-nav' (doc 01/08).
 */
export function NavRail({ aiEnabled }: { aiEnabled: boolean }) {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(NAV_STORAGE_KEY) === "collapsed";
    } catch {
      return false;
    }
  });

  const toggle = () => {
    setCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem(NAV_STORAGE_KEY, next ? "collapsed" : "expanded");
      } catch {
        /* private mode */
      }
      return next;
    });
  };

  return (
    <nav className={styles.rail} data-collapsed={collapsed} aria-label="Primary">
      <div className={styles.head}>
        <button
          type="button"
          className={styles.collapseBtn}
          onClick={toggle}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <Icon name="chevron" size={16} />
        </button>
        {!collapsed && <span className={`t-eyebrow ${styles.headTitle}`}>Workspace</span>}
      </div>
      {NAV.map((group) => {
        const items = group.items.filter((i) => !i.aiGated || aiEnabled);
        if (items.length === 0) return null;
        return (
          <div key={group.group} className={styles.group}>
            {!collapsed && <p className={`t-eyebrow ${styles.groupLabel}`}>{group.group}</p>}
            {items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) => `${styles.item} ${isActive ? styles.active : ""}`}
                title={item.label}
              >
                <Icon name={item.icon} size={17} />
                {!collapsed && <span>{item.label}</span>}
              </NavLink>
            ))}
          </div>
        );
      })}
    </nav>
  );
}
